export default "__VITE_ASSET__CH4vMqId__"